import { type UseModalState } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { useIsArrivalTimeEligible } from "@src/appV2/redesign/ArrivalTime/useIsArrivalTimeEligible";
import { differenceInMinutes, parseISO } from "date-fns";
import { useParams } from "react-router-dom";

import { useShiftInviteSnapshot } from "../hooks/useShiftInviteSnapshot";
import { ShiftInviteRegularShiftBookedBottomSheetContainer } from "./RegularShiftBookedBottomSheetContainer";
import { ShiftInviteShortLeadTimeShiftBookedBottomSheetContainer } from "./ShortLeadTimeShiftBookedBottomSheetContainer";

interface ShiftInviteBookedBottomSheetContainerProps {
  modalState: UseModalState;
}

export function ShiftInviteBookedBottomSheetContainer(
  props: ShiftInviteBookedBottomSheetContainerProps
) {
  const { modalState } = props;
  const { shiftInviteId } = useParams<{ shiftInviteId: string }>();

  const { shiftInviteSnapshot } = useShiftInviteSnapshot(shiftInviteId ?? "");
  const { shiftInvite, computedArrivalData } = shiftInviteSnapshot ?? {};

  const isShortLeadTime = useIsArrivalTimeEligible({
    shiftStartIso: shiftInvite?.attributes.shiftDetails.start,
    workplaceType: shiftInvite?.attributes.facility.type,
    workplaceId: shiftInvite?.attributes.workplaceId ?? "",
    workplaceMsa: shiftInvite?.attributes.facility.fullAddress?.metropolitanStatisticalArea ?? "",
  });

  if (!isDefined(shiftInvite)) {
    return null;
  }

  const shouldAlreadyLeave =
    isDefined(computedArrivalData) &&
    isDefined(shiftInvite) &&
    (parseISO(shiftInvite.attributes.shiftDetails.start) < computedArrivalData.targetArrivalTime ||
      differenceInMinutes(computedArrivalData.departureTime, new Date()) <=
        computedArrivalData.gracePeriodInMinutes);

  return isShortLeadTime && shouldAlreadyLeave ? (
    <ShiftInviteShortLeadTimeShiftBookedBottomSheetContainer
      modalState={modalState}
      shiftInvite={shiftInvite}
    />
  ) : (
    <ShiftInviteRegularShiftBookedBottomSheetContainer
      modalState={modalState}
      shiftInvite={shiftInvite}
    />
  );
}
